import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import Modal from '../../common/modal';
import { controlRole } from '../../common/actions/controlRole';
import { playerActions } from '../../store/actions';
import './style.scss';

/**
 * Menu azioni (tre pallini) sulla riga di una licenza.
 * Usato nella pagina Licenze e nel tab Licenze del dettaglio utente.
 *
 * Azioni:
 * - Libera licenza: visibile solo se la licenza ha un dispositivo associato e l'utente ha il permesso api/Player/FreeLicence - PUT.
 *   Chiede conferma, chiama il BE e la lista delle licenze viene ricaricata con gli stessi filtri.
 *
 * Se non c'è nessuna azione disponibile il menu non viene mostrato.
 *
 * @param {Object} licence licenza della riga (key, playerId)
 * @param {Array} data lista delle licenze in tabella (con poche righe il menu viene posizionato fixed per non essere tagliato)
 */
class ActionMenuLicence extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmOpen: false,
            // evita doppi invii mentre la richiesta è in corso
            sending: false
        }
    }

    toggleConfirm = () => {
        this.setState(prev => ({ confirmOpen: !prev.confirmOpen }));
    }

    confirm = () => {
        this.setState({ confirmOpen: false, sending: true });
        Promise.resolve(this.props.freeLicence(this.props.licence.key))
            .finally(() => this.setState({ sending: false }));
    }

    render() {
        const { licence, role, data } = this.props;

        const canFreeLicence = !!licence && !!licence.playerId && controlRole(role.player, "api/Player/FreeLicence", "PUT");

        if (!canFreeLicence) return null;

        return (
            <Fragment>
                <div className="dropdown">
                    <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" aria-label="Azioni licenza">
                        <i className="fas fa-ellipsis-v"></i>
                    </button>
                    <ul className={!data || data.length < 4 ? "dropdown-menu fixed" : "dropdown-menu"}>
                        <li>
                            <div className={this.state.sending ? "dropdown-item disabled" : "dropdown-item"} onClick={this.state.sending ? undefined : this.toggleConfirm}>
                                <i className={this.state.sending ? "fas fa-spinner fa-spin orange" : "fas fa-unlink orange"}></i>
                                {this.state.sending ? 'Liberazione in corso...' : 'Libera licenza'}
                            </div>
                        </li>
                    </ul>
                </div>

                <Modal
                    titleModal="Libera licenza"
                    contentModal={
                        <Fragment>
                            <p>
                                Liberare la licenza <b className="licenceCode">{licence.key}</b> dal dispositivo <b className="licenceCode">{licence.playerId}</b>?
                            </p>
                            <p className="mb-0">
                                Il dispositivo perderà la licenza; il TV del cliente la riprenderà al prossimo avvio o inserendo il codice.
                            </p>
                        </Fragment>
                    }
                    click={this.confirm}
                    toggle={this.toggleConfirm}
                    stateModal={this.state.confirmOpen}
                    confirmLabel="Libera licenza"
                    confirmClass="btn-warning"
                    showCancel
                />
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    role: state.role
});

const mapDispatchToProps = dispatch => ({
    freeLicence: (licenceKey) => dispatch(playerActions.freeLicence(licenceKey))
});

export default connect(mapStateToProps, mapDispatchToProps)(ActionMenuLicence);
